import React, { useRef } from 'react';
import {
  Dropdown,
  Popover,
  Whisper,
  WhisperInstance,
  Stack,
  Avatar,  
} from 'rsuite';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import { logout } from '@/services/auth.service';


const renderAdminSpeaker = ({ onClose, left, top, className }: any, ref) => {  
  const handleSelect = eventKey => {
    onClose();
    if (eventKey == 1) {
      logout();      
      window.location.reload();

    }
    console.log(eventKey);
  };
  return (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu onSelect={handleSelect}>
        <Dropdown.Item panel style={{ padding: 10, width: 160 }}>
          <p>Signed in as</p>
          <strong>Administrator</strong>
        </Dropdown.Item>
        <Dropdown.Separator />
        <Dropdown.Item>Settings</Dropdown.Item>
        <Dropdown.Item eventKey={1}>Sign out</Dropdown.Item>
        <Dropdown.Item
          icon={<HelpOutlineIcon />}
          href="https://elites.com"
          target="_blank"
          as="a"
        >
          Help{' '}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );
};

interface HeaderProps {
  profilePicture?: string|undefined;
}
const Header = ({profilePicture}: HeaderProps) => {
  const trigger = useRef<WhisperInstance>(null);

  return (
    <Stack className="header" spacing={8}>   
      <Whisper placement="bottomEnd" trigger="click" ref={trigger} speaker={renderAdminSpeaker}>
        {profilePicture ? <Avatar src={profilePicture} /> : <Avatar /> }
      </Whisper>
    </Stack>
  );
};

export default Header;
